// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1qhWU","footer":"ReportModalFilter_footer__39LQT"};